__turbopack_context__.v({
  "actions": "FetchDesign-module___9gQyW__actions",
  "art": "FetchDesign-module___9gQyW__art",
  "chips": "FetchDesign-module___9gQyW__chips",
  "decline": "FetchDesign-module___9gQyW__decline",
  "inline": "FetchDesign-module___9gQyW__inline",
  "inlineArt": "FetchDesign-module___9gQyW__inlineArt",
  "inlineBody": "FetchDesign-module___9gQyW__inlineBody",
  "inlineCopy": "FetchDesign-module___9gQyW__inlineCopy",
  "inlineHeadRow": "FetchDesign-module___9gQyW__inlineHeadRow",
  "inlineTitle": "FetchDesign-module___9gQyW__inlineTitle",
  "inlineTop": "FetchDesign-module___9gQyW__inlineTop",
  "logoCard": "FetchDesign-module___9gQyW__logoCard",
  "mobile": "FetchDesign-module___9gQyW__mobile",
  "mobileArt": "FetchDesign-module___9gQyW__mobileArt",
  "mobileHeadRow": "FetchDesign-module___9gQyW__mobileHeadRow",
  "offerBarTagged": "FetchDesign-module___9gQyW__offerBarTagged",
  "panelTagIcon": "FetchDesign-module___9gQyW__panelTagIcon",
  "panelTagged": "FetchDesign-module___9gQyW__panelTagged",
  "quoteNote": "FetchDesign-module___9gQyW__quoteNote",
  "quoteNoteLeft": "FetchDesign-module___9gQyW__quoteNoteLeft",
  "quoteStack": "FetchDesign-module___9gQyW__quoteStack",
  "quoteStackDecline": "FetchDesign-module___9gQyW__quoteStackDecline",
  "sub": "FetchDesign-module___9gQyW__sub",
  "t1Art": "FetchDesign-module___9gQyW__t1Art",
  "t1Card": "FetchDesign-module___9gQyW__t1Card",
  "t1Copy": "FetchDesign-module___9gQyW__t1Copy",
  "t1Main": "FetchDesign-module___9gQyW__t1Main",
  "t2Art": "FetchDesign-module___9gQyW__t2Art",
  "t2Body": "FetchDesign-module___9gQyW__t2Body",
  "t2Copy": "FetchDesign-module___9gQyW__t2Copy",
  "tagIcon": "FetchDesign-module___9gQyW__tagIcon",
  "teaserArt": "FetchDesign-module___9gQyW__teaserArt",
  "title": "FetchDesign-module___9gQyW__title",
  "trustpilot": "FetchDesign-module___9gQyW__trustpilot",
});
